import { Dispatch, SetStateAction } from 'react';

import { ardotAttributeDictionary } from '@atom/components/common/requests/customTenantUtilities';
import {
  ARDOTAttribute,
  AssetRequestCreateInput,
} from '@atom/types/assetRequest';
import { InventoryAssetDetailType } from '@atom/types/inventory';
import { UserDetail } from '@atom/types/user';

import { View } from '../CreateRequestModal';

import ApprovalSection from './ApprovalSection';
import AttributesSection from './AttributesSection';
import TransferSection from './TransferSection';

import classes from './ardotCreate.module.css';

interface Props {
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  asset: InventoryAssetDetailType;
  setView: Dispatch<SetStateAction<View>>;
  transferToggle: boolean;
  setTransferToggle: Dispatch<SetStateAction<boolean>>;
  selectedOperatorUser: UserDetail;
  setSelectedOperatorUser: Dispatch<SetStateAction<UserDetail>>;
}

const ARDOT118TransferCreate = ({
  asset,
  createInputs,
  updateCreateInput,
  setView,
  transferToggle,
  setTransferToggle,
  selectedOperatorUser,
  setSelectedOperatorUser,
}: Props) => {
  const attributeDictionary = ardotAttributeDictionary(asset);

  return (
    <>
      <div>
        <div className={classes.rowTitle}>{ARDOTAttribute.TAG_NUMBER}</div>
        <div>
          {attributeDictionary[ARDOTAttribute.TAG_NUMBER]?.value || '-'}
        </div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>{ARDOTAttribute.DESCRIPTION}</div>
        <div>
          {attributeDictionary[ARDOTAttribute.DESCRIPTION]?.value || '-'}
        </div>
      </div>
      <AttributesSection
        asset={asset}
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
        selectedUser={selectedOperatorUser}
        setSelectedUser={setSelectedOperatorUser}
      />
      <TransferSection
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
        setView={setView}
        transferToggle={transferToggle}
        setTransferToggle={setTransferToggle}
      />
      <ApprovalSection
        asset={asset}
        createInputs={createInputs}
        updateCreateInput={updateCreateInput}
      />
    </>
  );
};

export default ARDOT118TransferCreate;
